
import { Component, Mixins, Prop } from 'vue-property-decorator'

import { Nullable } from '@/@next/@types'

import { CustomTagMixin } from '@/@next/mixins'
import { messages } from '@/@next/i18n'
import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'

const config = {
  name: 'c-person-card',
  i18n: { messages },
  components: {
    CButton, CButtonLabel, CButtonIcon
  }
}

@Component(config)
export default class PersonCard extends Mixins(CustomTagMixin) {
  @Prop({ type: Boolean }) loading!: boolean
}
